<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67">
		<path d="M33.5,67A33.509,33.509,0,0,1,20.46,2.633,33.508,33.508,0,0,1,46.539,64.367,33.291,33.291,0,0,1,33.5,67ZM26.472,20.867a.615.615,0,0,0-.592.634v23.21a.619.619,0,0,0,.6.637.559.559,0,0,0,.3-.086l18.4-11.605a.657.657,0,0,0,0-1.094l-18.4-11.605A.559.559,0,0,0,26.472,20.867Z" fill="currentColor"/>
	</svg>
</template>
